import * as React from 'react';
import { getActionPlanList } from '../../../api/actionPlanClientApi';
import { appUrlBuilder } from '../../../utils/appUrlBuilder';
import { DashboardCard } from './DashboardCard';
import { DashboardCardContent } from './DashboardCardContent';


export function DashboardActionplanCard(): JSX.Element {

    const [actionplans, setActionPlans] = React.useState([]);
    
    const getData = async () => {
        // Only non-finished action plans should be shown
        const actionplans = (await getActionPlanList())
            .filter(ap => ap.end > new Date())
            .sort(a => a.start.getTime() - new Date().getTime());

        setActionPlans(actionplans);
    };
    React.useEffect(() => { 
        getData(); 
    }, []);

    const actionPlan = actionplans.length > 0 ? actionplans[0] : null;

    return (
        <DashboardCard backgroundColor="white">
            
            {actionPlan ? (
                <DashboardCardContent 
                    title="Handleplan"
                    activityStatus={`Aktuel handleplan ${actionPlan.start.toLocaleDateString()} - ${actionPlan.end.toLocaleDateString()}`}
                    activityLink={appUrlBuilder.actionPlan.fromDashboard(actionPlan.id)}
                    activityTitle={actionPlan.title}
                    icon="fact_check"
                />
                ) : (
                <DashboardCardContent 
                    title="Handleplan"
                    activityStatus="Ingen aktuelle handleplaner"
                    activityLink={appUrlBuilder.actionPlan.list()}
                    activityTitle="Opret en handleplan"
                    createNew={true}
                    icon="fact_check"
                />
                )}
        </DashboardCard>
    );
}
